export default class Toast {
    static addToast() {
        var toasts = document.getElementById('toasts');
        toasts.innerHTML += `<div class="toast show align-items-center text-dark bg-primary border-0" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
          <div class="toast-body">
            Your new password has been set!
          </div>
          <button type="button" class="btn-close btn-close-dark me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
      </div>`;
    }    
}